export default "assets/images/phone-aba13fd4.svg";